<div class="onboarding-step-wrapper">
    <h2>Auto-execute actions</h2>
    <div class="onboarding-blurb">
        <p>An initial set of asset maintenance actions relating to scheduled activities such as cleaning or painting can be automatically
            generated and executed.
        </p>
    </div>
    <ng-container *ngIf="!isLoading else showLoader">
        <div class="onboarding-prompt-wrapper">
            <ng-container *ngIf="active else showInactive">
                <p class="onboarding-prompt">Auto-execute actions is on.<br/>Do you want to turn auto-execute actions off?</p>
                <button (click)="submit(false)" class="cas-button-action">Turn off</button>
            </ng-container>

            <ng-template #showInactive>
                <p class="onboarding-prompt">Auto-execute actions is off.<br/>Do you want to turn auto-execute actions on?</p>
                <button (click)="submit(true)" class="cas-button-action">Turn on</button>
            </ng-template>
        </div>
    </ng-container>

    <ng-template #showLoader>
        <acabim-loading-view></acabim-loading-view>
    </ng-template>

</div>


